export default __webpack_public_path__ + "static/media/O.fe778cda.svg";